import React from "react";
import { Divider, Stack, Typography, Link as MuiLink } from "@mui/material";
import { useTranslation } from "react-i18next";

import { RoutePaths } from "src/app/model";
import { useLocale } from "src/shared/i18n";

export const CopyRight: React.FC = () => {
  const { t } = useTranslation();
  const { toRoute } = useLocale();

  return (
    <Stack
      width={1}
      direction="column"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="body2" color="primary">
        {t("copyright.name")}
      </Typography>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <Typography variant="caption" color="textSecondary">
          {t("copyright.rights", { year: new Date().getFullYear() })}
        </Typography>
        <Divider
          orientation="vertical"
          flexItem
          variant="fullWidth"
          sx={{
            borderColor: "text.secondary",
          }}
        />
        <MuiLink
          target="_blank"
          href={toRoute(RoutePaths.PRIVACY_POLICY)}
          color="textSecondary"
          sx={{
            cursor: "pointer",
          }}
        >
          <Typography variant="caption" color="textSecondary">
            {t("copyright.privacyPolicy")}
          </Typography>
        </MuiLink>
      </Stack>
    </Stack>
  );
};
